<template>
  <div class="row row-spacing">
    <div class="col-md-12">
      <div class="card table-responsive table-bordered" v-if="documents.length">
        <table class="table">
          <thead>
            <tr>
              <th class="clickable" @click="sortBy('description')">Description
                <i class="fa fa-sort-asc float-right" v-if="sortKey == 'description' && reverse"></i>
                <i class="fa fa-sort-desc float-right" v-if="sortKey == 'description' && !reverse"></i>
              </th>
              <th class="clickable" @click="sortBy('fileName')">File
                <i class="fa fa-sort-asc float-right" v-if="sortKey == 'fileName' && reverse"></i>
                <i class="fa fa-sort-desc float-right" v-if="sortKey == 'fileName' && !reverse"></i>
              </th>
              <th class="clickable" @click="sortBy('type')">Type
                <i class="fa fa-sort-asc float-right" v-if="sortKey == 'type' && reverse"></i>
                <i class="fa fa-sort-desc float-right" v-if="sortKey == 'type' && !reverse"></i>
              </th>
              <th class="clickable" @click="sortBy('created')">Uploaded
                <i class="fa fa-sort-asc float-right" v-if="sortKey == 'created' && reverse"></i>
                <i class="fa fa-sort-desc float-right" v-if="sortKey == 'created' && !reverse"></i>
              </th>
              <th class="clickable" @click="sortBy('expirationDate')">Expiry Date
                <i class="fa fa-sort-asc float-right" v-if="sortKey == 'expirationDate' && reverse"></i>
                <i class="fa fa-sort-desc float-right" v-if="sortKey == 'expirationDate' && !reverse"></i>
              </th>
              <th style="width:7em"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="doc in sortedDocuments" :key="doc.supplierDocumentNumber" :class="{'new-table-row': doc.isNew}">
              <td>{{doc.description}}</td>
              <td><a href="javascript:void(0)" @click="downloadDocument(doc.supplierDocumentNumber)">{{doc.fileName}}</a></td>
              <td>{{documentType(doc, documentTypes)}}</td>
              <td>{{doc.created.split(" ")[0]}}</td>
              <td>{{doc.expirationDate.split(" ")[0] == '1970-01-01' ? '' : doc.expirationDate.split(" ")[0]}}</td>
              <td class="text-center">
                <button class="btn btn-sm btn-info m-1" type="button"
                  v-tooltip="'Edit Document Details'"
                  @click="openEditModal(doc)">
                  <em class="fa fa-edit fa-fw"></em>
                </button>
                <button 
                  class="btn btn-sm btn-primary" type="button"
                  v-tooltip="'Delete Document'" 
                  v-allowed:view="['STAFF']"
                  @click="deleteDocument(doc.supplierDocumentNumber)">
                  <em class="fa fa-trash fa-fw"></em>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        No Documentation Found
      </div>
    </div>

    <modal title="Edit Document Details" ref="editDocumentModal" @save="updateDocument(selectedDocument)">
      <div class="form-group">
        <label>File Name</label>
        <p>
          <strong>{{selectedDocument.fileName}}</strong>
        </p>
      </div>
      <div class="form-group">
        <label>Type</label>
        <v-select :options="documentTypes" label="description" v-model="selectedDocument.type" valueProp="name"></v-select>
      </div>
      <div class="form-group">
        <label>Description</label>
        <input type="text" class="form-control" v-model="selectedDocument.description">
      </div>
      <div class="form-group">
        <label>Expiration Date</label>
        <div class="input-group">
          <input
            v-model="expirationDateInput"
            type="date"
            class="form-control"
          />
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
  import Modal from '@/components/GeneralComponents/Modal'
  import Popper from 'vue-popperjs';
  import 'vue-popperjs/dist/vue-popper.css';
  
  export default {
    components: {
      Modal,
      'popper': Popper
    },
    computed: {
      expirationDateInput: {
        get() {
          if (!this.selectedDocument.expirationDate) {
              return "";
          }

          const normalizedDate = this.selectedDocument.expirationDate.split(" ")[0];
          return normalizedDate === "1970-01-01" ? "" : normalizedDate;
        },
        set(value) {
          this.selectedDocument.expirationDate = value && value.length > 0 ? value : "1970-01-01";
        },
      },
      sortedDocuments() {
        if (this.reverse) {
          return _.orderBy(this.documents, this.sortKey, 'asc');
        } else {
          return _.orderBy(this.documents, this.sortKey, 'desc');
        }
      },
      documentType: () => ({
        type
      }, documentTypes) => {
        const t = documentTypes.find(t => t.name === type);
        if (t) {
          return t.description;
        } else {
          return "ERROR (Report to Dev)";
        }
      },
    },
    props: {
      documents: {
        type: Array,
        required: true
      },
      supplierNumber: {
        type: [Number, String],
        required: true,
      },
      documentTypes: {
        type: Array,
        required: true
      },
    },
    data() {
      return {
        selectedDocument: {
          fileName: '',
          type: '',
          description: '',
          expirationDate: '1970-01-01',
        },
        searchText: '',

        sortKey: 'created',
        reverse: false,
      }
    },
    methods: {
      downloadDocument(docNumber) {
        this.$http.get(this.$config.aimsAPIv3 + "suppliers/" + this.supplierNumber + "/documents/" + docNumber + "/download", {
            responseType: 'arraybuffer'
          })
          .then(function (response) {
            const contentType = response.headers.get('Content-Type');
            let blob = new Blob([response.data], {
              type: contentType
            });
            const fileName = response.headers.get('Content-Disposition').split("filename = ")[1];
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.dispatchEvent(new MouseEvent('click', {
              bubbles: true,
              cancelable: true,
              view: window
            }));
          }, function (error) {
            console.error(error);
            this.showError('Error Downloading Correspondence', error.data);
          });
      },
      deleteDocument(docNumber) {
        this.$swal({
          title: 'Are you sure you want to delete this document?',
          text: 'Document #' + docNumber,
          type: 'warning',
          showCancelButton: true,
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes'
        }).then(result => {
          if (result.value) {
            this.$http.delete(this.$config.aimsAPIv3 + "suppliers/" + this.supplierNumber + "/documents/" + docNumber + "/delete")
              .then(response => {
                  this.showSuccess('Successfully deleted Document');
                  this.$emit('loadDocuments');
                },
                error => {
                  this.showError('Error deleting Document', error)
                  console.error(error);
                });
          }
        })
      },
      openEditModal(doc) {
        this.selectedDocument = this.deepCopyObject(doc);
        this.$refs.editDocumentModal.open();
      },
      updateDocument(doc) {
        this.$refs.editDocumentModal.isLoading();
        this.$http.put(this.$config.aimsAPIv3 + 'suppliers/documents/update', doc)
          .then(response => {
              this.$emit('loadDocuments');
              this.$refs.editDocumentModal.close();
            },
            error => {
              this.$refs.editDocumentModal.isLoading();
              this.showError("Error updating document", error);
              console.error(error);
            });
      },
      sortBy(sortKey) {
        this.reverse = (this.sortKey == sortKey) ? ! this.reverse : false;
        this.sortKey = sortKey;
      },
    }
  }

</script>

<style scoped>
.clickable:hover {
 cursor: pointer;
}

.table>thead>tr>th {
  background-color: #3a3f51;
  color: #FFFFFF; 
  padding: 1em;

  top: 0;
  z-index: 2;
  position: sticky;
} 
</style>
